module.exports = __webpack_public_path__ + "img/dongji_ps_07.089af2db.jpg";